module.exports = __webpack_public_path__ + "img/holographicreallife.446c3a8a.png";